import {createDialog, createLoadingDialog} from './dialog';
import {addBatchItem} from './batch-menu';
import {reloadDataTables} from './datatable';
import {displayInlineLayoutOptions} from './layout-selector';
import {displayNoPreviewWarningDialog} from './preview';

// @ts-ignore
let $ = window.jQuery;

function submitEmailForm(dialog: DialogElement, $form: JQuery<HTMLFormElement>) {
    $('#email_certificate_errors', dialog).html('');

    dialog.hide();
    let loader = createLoadingDialog(`<h2>${PDFGenerator.text_sending_emails}</h2>`);
    $.post({
        url: PDFGenerator.ajax_url,
        data: $form.serialize(),
    }).done(function (response: WordpressAJAXResponse) {
        loader.remove();
        if (response.success) {
            dialog.find('.gf-pdf-modal-header').remove();
            dialog.find('.gf-pdf-modal-content').html(`<div><div class="gf-pdf-modal-centered">
${response.data.message}
</div><div class="gf-pdf-modal-footer"><button class="gf-pdf-button gf-pdf-modal-close -centered" type="submit">${PDFGenerator.text_continue}</button></div></div>`);
            dialog.show();

            reloadDataTables();
        } else {
            dialog.show();
            $('#email_certificate_errors').html(response.data.message);
        }
    });
}


function createEmailDialog(entryIDs: number[], actionKey: string) {
    let dialog;
    const entryIDsInput = entryIDs.map((entryID) => {
        return `<input type="hidden" name="entry_ids[]" value="${entryID}">`;
    });

    const title = entryIDs.length > 1 ? PDFGenerator.text_modal_emails_to_recipient.replace('##', entryIDs.length.toString()) : PDFGenerator.text_modal_email_to_recipient;

    const subject_label = entryIDs.length > 1 ? PDFGenerator.text_label_email_subject_multiple_recipients : PDFGenerator.text_label_email_subject_single_recipient;
    const content_label = entryIDs.length > 1 ? PDFGenerator.text_label_email_message_multiple_recipients : PDFGenerator.text_label_email_message_single_recipient;

    let placeholdersBlock = '';
    if (PDFGeneratorFormSettings.pdf_email_placeholders.length > 0) {
        placeholdersBlock += `<p>${PDFGenerator.text_description_email_message}</p><ul>`;

        PDFGeneratorFormSettings.pdf_email_placeholders.forEach((placeholder) => {
            placeholdersBlock += `<li>
                <strong>${placeholder.placeholder}</strong> ${placeholder.description}
                </li>`;
        });
        placeholdersBlock += '</ul>';
    }

    let layoutSelectionBlock = '';
    if (PDFGeneratorFormSettings.pdf_layout.length > 0) {
        layoutSelectionBlock = displayInlineLayoutOptions();
    }

    dialog = createDialog(`<h2>${title}</h2>`, `<form method="post">

    <div class="gf-pdf-notice-info">${PDFGenerator.text_modal_emails_description}</div>

    <p>
        <label>${subject_label}</label>
        <input class="gf-pdf-input-field" type="text" name="email_subject" value="${PDFGeneratorFormSettings.pdf_email_subject}">
</p>
    <p>
        <label>${content_label}</label>
        <textarea class="gf-pdf-input-field" name="email_content">${PDFGeneratorFormSettings.pdf_email_body}</textarea>
</p>    
        ${placeholdersBlock}
    <p>
        <label>${PDFGenerator.text_label_email_reply_to}</label>
        <input class="gf-pdf-input-field" type="email" name="reply_to" value="">
</p>    
        <p>${PDFGenerator.text_description_email_reply_to}</p>
        
        ${layoutSelectionBlock}
        
        <div class="gf-pdf-error" id="email_certificate_errors"></div>
        ${entryIDsInput.join('')}
        <input type="hidden" name="action" value="pdf_action">
        <input type="hidden" name="action_key" value="${actionKey}">
        <div class="gf-pdf-modal-footer">
                <button type="button" class="gf-pdf-button -cancel gf-pdf-modal-close" value="cancel">${PDFGenerator.text_cancel}</button>
                <button type="submit" class="gf-pdf-button gf-pdf-send-certificate">${PDFGenerator.text_button_send_email}</button>
        </div>
        </form>`);
    dialog[0].showModal();


    dialog.on('submit', 'form', function (e: Event) {
        e.preventDefault();
        const layoutId = $('input[name="pdf_layout"]:checked').val() as string;
        const $form = $(this);
        displayNoPreviewWarningDialog(PDFGeneratorFormSettings.actions['full_print_with_signature'], entryIDs, layoutId, function () {
            submitEmailForm(dialog, $form);
        });
    });
}

export function addEmailButton() {
    if (PDFGeneratorFormSettings.actions['email_with_signature']) {
        addBatchItem($(`<button type="button" class="gf-pdf-button email-selected-pdfs">${PDFGenerator.text_email_selected_pdfs}</button>`))
    }
}

jQuery(function ($) {
    $('body').on('click', '.email-selected-pdfs', function (e) {
        const entryIds = $('input[name="entries[]"]:checked').map(function () {
            return $(this).val() as number;
        }).get();

        $('body').trigger('email_with_signature', [PDFGeneratorFormSettings.actions['email_with_signature'], entryIds]);
    }).on('email_with_signature', function (e, action: PDFAction, entryIDs: number[], preselectedLayoutId: string | null) {
        createEmailDialog(entryIDs, e.type);
    });
});